import Arrow from "@/common/icons/arrow"
import Image from "next/legacy/image"
import { useEffect, useRef, useState } from "react"
import { A11y, Navigation } from "swiper/modules"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import {
  ActivityLabel,
  getCategoryIcon
} from "../wild-neighbors-register/form-activity/activity"
import {
  allowedDocumentTypes,
  allowedImageTypes
} from "../wild-neighbors-register/form-activity/files"
import { ImagePlaceholder } from "./image-placeholder"
import { Icon } from "../wild-neighbors-register/icon"
import styles from "@/components/blocks/theme/wild-neighbors-map/swiper.module.css"
import classNames from "classnames"

export function ActivityCard({ activities = [], activity }) {
  const prevRef = useRef(null)
  const nextRef = useRef(null)
  const [mounted, setMounted] = useState(false)

  useEffect(() => setMounted(true), [])
  const images = activity.files.filter((file) => {
    return allowedImageTypes.includes(file.type) && file.id !== ""
  })

  const documents = activity.files.filter((file) => {
    return allowedDocumentTypes.includes(file.type)
  })

  if (!activities) {
    return null
  }

  return (
    <div className="rounded-[4px] overflow-hidden">
      {images.length > 0 ? (
        mounted ? (
          <Swiper
            className={classNames(styles.swiper, {
              "one-image": images.length === 1
            })}
            modules={[Navigation, A11y]}
            slidesPerView={1}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevRef.current
              swiper.params.navigation.nextEl = nextRef.current
            }}>
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <figure className="relative aspect-w-4 aspect-h-3">
                  <Image
                    src={image.url}
                    alt={image.name_original}
                    layout="fill"
                    objectFit="cover"
                  />
                </figure>
              </SwiperSlide>
            ))}
            <button
              ref={prevRef}
              type="button"
              aria-label="Föregående"
              className="nav-button prev swiper-nav-prev swiper-nav">
              <Arrow />
            </button>
            <button
              ref={nextRef}
              type="button"
              aria-label="Nästa"
              className="nav-button swiper-nav-next swiper-nav">
              <Arrow />
            </button>
          </Swiper>
        ) : null
      ) : (
        <figure className="relative aspect-w-4 aspect-h-3">
          <ImagePlaceholder className="object-cover" />
        </figure>
      )}
      <div className="p-4 bg-white">
        <div className="flex items-start gap-4 mb-2">
          <div>
            <Icon svg={getCategoryIcon(activities, activity.activity)} />
          </div>
          <div>
            <h5 className="mb-2 font-sans font-medium">
              <ActivityLabel
                activities={activities}
                activity={activity.activity}
              />
            </h5>
            <span className="block text-xs leading-3 font-bold uppercase tracking-[1px]">
              {activity.status === 0 ? (
                <>
                  <span className="inline-block mr-2 rounded-full w-3 h-3 bg-[#F8AF8F]"></span>
                  <span className="relative -top-[1px]">Planerad</span>
                </>
              ) : (
                <>
                  <span className="inline-block w-3 h-3 mr-2 rounded-full bg-summer-green-100"></span>
                  <span className="relative -top-[1px]">Genomförd</span>
                </>
              )}
            </span>
          </div>
        </div>
        <p className="text-base">{activity.description}</p>
        {documents.length > 0 && (
          <ul>
            {documents.map((document, index) => (
              <li key={index} className="mt-2">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={document.url}
                  className="text-base font-bold underline">
                  {document.name_original}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}
